<script>
import { QInput } from 'quasar'
import FieldIconMixin from './FieldIconMixin.js'
import FieldProxyMixin from './FieldProxyMixin.js'
import FieldDenseMixin from './FieldDenseMixin'
import _ from 'lodash'

const lazyRulesValues = [true, false, 'ondemand']

export default {
  props: {
    counter: {
      type: Boolean,
      default: true
    },
    clearable: {
      type: Boolean,
      default: null
    },
    clearIcon: {
      type: String,
      default: 'close'
    },
    lazyRules: {
      type: [Boolean, String],
      validator: v => lazyRulesValues.includes(v),
      default: true
    },
    noErrorIcon: {
      type: Boolean,
      default: true
    },
    disable: {
      type: Boolean,
      default: null
    },
    readonly: {
      type: Boolean,
      default: null
    },
    labelColor: {
      type: String,
      default: 'black'
    }
  },
  mixins: [FieldIconMixin, FieldProxyMixin, FieldDenseMixin],
  render (createElement) {
    return createElement(QInput, {
      ref: 'input',
      props: {
        ...this.$props,
        dense: this.computedDense,
        disable: false,
        readonly: this.disable || this.readonly,
        clearable: _.isNil(this.clearable) ? (this.$attrs.type !== 'number') : this.clearable
      },
      attrs: { ...this.$attrs },
      on: this.$listeners,
      scopedSlots: Object.assign({
        prepend: this.slotPrependIcon(createElement)
      }, this.$scopedSlots)
    })
  }
}
</script>
